import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';

import Styled from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);

const RenderComponent = ({
  values,
  handleEdit,
  validateForm,
  customProps,
  submitAction,
  errors,
  isNotValid,
}) => {
  const { i18n } = useTranslation();

  const showError = (field) => {
    const apiError = customProps?.hasApiStatus?.errorMessage;
    if (errors[field] && !isNotValid) {
      return <Message type="error" message={errors[field]} />;
    }
    if (apiError?.[field]) {
      return <Message type="error" message={apiError[field]} />;
    }
    return null;
  };

  const renderField = (id, name, labelKey, type = 'text', additionalProps = {}) => (
    <FormStyle.default.FieldsWrapper width="100%" className="fieldSection">
      <Label variant="body1" htmlFor={id}>
        {i18n.t(labelKey)}
      </Label>
      <FormStyle.default.TextWrapper>
        <Field
          id={id}
          name={name}
          value={values?.[name]}
          as={Input}
          type={type}
          handleOnChange={(event) => handleEdit(event, { field: name })}
          {...additionalProps}
        />
        {showError(name)}
      </FormStyle.default.TextWrapper>
    </FormStyle.default.FieldsWrapper>
  );

  const handleSubmit = () => {
    validateForm().then((data) => submitAction(data));
  };

  return (
    <Styled.PopupUpload>
      <SubHeader text={i18n.t('parts.partTitle')} variant="h2" />
      <Styled.UploadWrapper>
        <div className="uploadFields">
          {renderField('partName', 'partName', 'parts.partName')}
          {renderField('partsInInventory', 'partsInInventory', 'parts.partsInventory', 'number', {
            updateValue: (event) => event?.replace(/\D/g, ''),
          })}
          {renderField('cost', 'cost', 'parts.cost', 'text', {
            disabled: !!values?.id,
          })}
          <FormStyle.default.ButtonsWrapper className="saveAction">
            <Button
              type="submit"
              className="buttonStyle"
              label={i18n.t('common.save')}
              onClick={handleSubmit}
            />
          </FormStyle.default.ButtonsWrapper>
        </div>
      </Styled.UploadWrapper>
    </Styled.PopupUpload>
  );
};

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};

export default RenderComponent;